export default function ProcessIconThree() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="72"
      fill="none"
      viewBox="0 0 72 72"
    >
      <rect width="72" height="72" fill="#E5F8EB" rx="36" />
      <path
        fill="#00B63E"
        d="M36 52c-5.75 0-11-3-13.875-8-2.875-4.938-2.875-11 0-16C25 23.062 30.25 20 36 20c5.688 0 10.938 3.063 13.813 8 2.874 5 2.874 11.063 0 16-2.876 5-8.126 8-13.813 8Zm7.063-18.938H43c.625-.562.625-1.5 0-2.124a1.471 1.471 0 0 0-2.063 0l-6.937 7L31.062 35c-.625-.625-1.562-.625-2.125 0a1.369 1.369 0 0 0 0 2.063l4 4c.563.624 1.5.624 2.126 0l8-8Z"
      />
    </svg>
  )
}
